import React from "react";
import "../assete/css/domanis.css";
import MetaTitle from '../components/MetaTittle';
import Header from "./Header";
import {  FaRobot, FaSignal, FaVolumeUp, FaAndroid } from 'react-icons/fa';
import { FaDatabase, FaFingerprint, FaBug, FaCloud } from 'react-icons/fa';
import { FaSatelliteDish, FaNetworkWired, FaLock, FaSearch } from 'react-icons/fa';
import { FaCamera, FaWaveSquare, FaProjectDiagram, FaMicrochip } from 'react-icons/fa';
import {  FaTruck, FaIndustry, FaXRay } from 'react-icons/fa';
import { FaHeartbeat, FaMobileAlt, FaBroadcastTower, FaShieldAlt } from 'react-icons/fa';
import { FaLightbulb, FaBolt, FaPlug, FaCogs } from 'react-icons/fa';
import { FaBrain, FaMicrophone, FaVideo } from 'react-icons/fa';
import {  FaGlobe, FaWifi, FaSatellite } from 'react-icons/fa';
import Footer from "./Footer";
import { faCar,  faNetworkWired, faLanguage, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck, faSolarPanel,  faAtom, faMicrochip } from '@fortawesome/free-solid-svg-icons';
import { faRobot, faSatellite, faCloud,  faVideo } from '@fortawesome/free-solid-svg-icons';
import { faSlidersH, faBolt, faEyeSlash, faWater } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faMountain, faLayerGroup, faRoad } from '@fortawesome/free-solid-svg-icons';
import {  faLeaf, faRecycle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faHardHat, faSatelliteDish } from '@fortawesome/free-solid-svg-icons';
import { faCubes, faCity, faThLarge } from '@fortawesome/free-solid-svg-icons';
import {  faTemperatureHigh, faIndustry, faCog } from '@fortawesome/free-solid-svg-icons';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { faMicroscope,  faBrain } from '@fortawesome/free-solid-svg-icons';
import { faPersonRunning, faGears,  faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import { faGasPump, faOilCan, faFireFlameCurved, faWaveSquare } from '@fortawesome/free-solid-svg-icons';
import { faCogs,  faFlaskVial, } from '@fortawesome/free-solid-svg-icons';
// import {   FaTools } from "react-icons/fa";
// import { FaPython } from "react-icons/fa";
// import { GiAtomicSlashes } from "react-icons/gi";
// import python from "../assete/images/python.webp";
// import block_chain from "../assete/images/block chain.jpg";
// import matlab from "../assete/images/matlab.webp";
// import ansys from "../assete/images/ansys 1.jpg";
// import cadence from "../assete/images/cadence.png";
// import cst from "../assete/images/cst.jpg";
// import tanner from "../assete/images/tanner.webp";
// import java from "../assete/images/java1.png";
// import ns2 from "../assete/images/ns2.png";
// import verilog from "../assete/images/verilog.webp";
// import comsol from "../assete/images/comsol.png";
// import blender from "../assete/images/blender.webp";
const Domains = () =>{

return(
    <>
      <MetaTitle title={"Domains | "} />
                  <meta name="description" content="MAATHANGI provides research guidance, thesis writing, and software development services in Marthandam, Tamil Nadu. Specializing in PhD assistance and software solutions." />
    <Header/>

    <div className="domain_maathagi_div"></div>

    <div className="maathagi_domain_main_div">
        <div className="maathagi_domain_main_div_4">
            <h1>DOMAINS</h1>
        </div>
        <div className="maathagi_domain_main_div_4">
        <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FaAndroid style={{ marginRight: "8px" }} /> Android OS</h2>
                <h2><FaSignal style={{ marginRight: "8px" }} /> Antenna Design</h2>
                <h2><FaRobot style={{ marginRight: "8px" }} /> Artificial Intelligence</h2>
                <h2><FaVolumeUp style={{ marginRight: "8px" }} /> Audio Signal Processing</h2>
            </div>
            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                         <h2><FaDatabase style={{ marginRight: '8px' }} />Big Data</h2>
                        <h2><FaFingerprint style={{ marginRight: '8px' }} />Biometric Signal Processing</h2>
                        <h2><FaBug style={{ marginRight: '8px' }} />Bio Inspired Algorithms</h2>
                        <h2><FaCloud style={{ marginRight: '8px' }} />Cloud Computing</h2>
                </div>
            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                        <h2><FaSatelliteDish style={{ marginRight: '8px' }} />Communication Systems</h2>
                        <h2><FaNetworkWired style={{ marginRight: '8px' }} />Computer Networks</h2>
                        <h2><FaLock style={{ marginRight: '8px' }} />Cryptography</h2>
                        <h2><FaSearch style={{ marginRight: '8px' }} />Data Mining</h2>
                </div>
            </div>
        </div>
         <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                        <h2><FaCamera style={{ marginRight: '8px' }} />Digital Image Processing</h2>
                        <h2><FaWaveSquare style={{ marginRight: '8px' }} />Digital Signal Processing</h2>
                        <h2><FaProjectDiagram style={{ marginRight: '8px' }} />Distributed Systems</h2>
                        <h2><FaMicrochip style={{ marginRight: '8px' }} />Embedded System</h2>
                </div>
            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                       <h2><FaNetworkWired style={{ marginRight: '8px' }} />High Speed Networks</h2>
                        <h2><FaTruck style={{ marginRight: '8px' }} />Logistics Management</h2>
                        <h2><FaIndustry style={{ marginRight: '8px' }} />Manufacturing Engineering</h2>
                        <h2><FaXRay style={{ marginRight: '8px' }} />Medical Image Processing</h2>
                </div>
            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                        <h2><FaHeartbeat style={{ marginRight: '8px' }} />Medical Signal Processing</h2>
                        <h2><FaMobileAlt style={{ marginRight: '8px' }} />Mobile Ad Hoc Network</h2>
                        <h2><FaBroadcastTower style={{ marginRight: '8px' }} />Mobile Communication</h2>
                        <h2><FaShieldAlt style={{ marginRight: '8px' }} />Network Security</h2>
                </div>
            </div>
        </div>
          <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                        <h2><FaLightbulb style={{ marginRight: '8px' }} />Optical Communication</h2>
                        <h2><FaBolt style={{ marginRight: '8px' }} />Power Electronics</h2>
                        <h2><FaPlug style={{ marginRight: '8px' }} />Power System</h2>
                        <h2><FaCogs style={{ marginRight: '8px' }} />Production Engineering</h2>
                </div>
            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                        <h2><FaBroadcastTower style={{ marginRight: '8px' }} />RF & Micro Waves</h2>
                        <h2><FaBrain style={{ marginRight: '8px' }} />Soft Computing</h2>
                         <h2><FaMicrophone style={{ marginRight: '8px' }} />Speech Processing</h2>
                         <h2><FaVideo style={{ marginRight: '8px' }} />Video Signal Processing</h2>
                </div>
            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                       <h2><FaMicrochip style={{ marginRight: '8px' }} />VLSI Design</h2>
                        <h2><FaGlobe style={{ marginRight: '8px' }} />Web Services</h2>
                        <h2><FaWifi style={{ marginRight: '8px' }} />Wireless Communication</h2>
                        <h2><FaSatellite style={{ marginRight: '8px' }} />Wireless Sensor Networks</h2>
                </div>
            </div>
             
        </div>

         <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faCar} className="domain-icon" /> VANET, Blockchain technology</h2>
                <h2><FontAwesomeIcon icon={faNetworkWired} className="domain-icon" /> Software Defined Networking</h2>
                <h2><FontAwesomeIcon icon={faLanguage} className="domain-icon" /> Natural Language Processing</h2>
                <h2><FontAwesomeIcon icon={faThumbsUp} className="domain-icon" /> Recommendation System</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
              <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faTruck} className="domain-icon" />Supply Chain Management IoT Security</h2>
                <h2><FontAwesomeIcon icon={faSolarPanel} className="domain-icon" /> Renewable Energy</h2>
                <h2><FontAwesomeIcon icon={faAtom} className="domain-icon" /> Quantum Computing</h2>
                <h2><FontAwesomeIcon icon={faMicrochip} className="domain-icon" /> Embedded FPGA</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faRobot} className="domain-icon" /> Robotics</h2>
                <h2><FontAwesomeIcon icon={faSatellite} className="domain-icon" /> Remote Sensing</h2>
                <h2><FontAwesomeIcon icon={faCloud} className="domain-icon" /> Edge and Fog Computing</h2>
                <h2><FontAwesomeIcon icon={faVideo} className="domain-icon" /> Video Surveillance</h2>
                </div>

            </div>
             
        </div>
        
         <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faSlidersH} className="domain-icon" /> Control System</h2>
                <h2><FontAwesomeIcon icon={faBolt} className="domain-icon" /> Smart Grid</h2>
                <h2><FontAwesomeIcon icon={faEyeSlash} className="domain-icon" /> Steganography and Watermarking</h2>
                <h2><FontAwesomeIcon icon={faWater} className="domain-icon" /> Underwater Sensor Networks (UWSN)</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faBuilding} className="domain-icon" /> Concrete and Steel Structures</h2>
                <h2><FontAwesomeIcon icon={faMountain} className="domain-icon" /> Geotechnical Engineering</h2>
                <h2><FontAwesomeIcon icon={faLayerGroup} className="domain-icon" /> Soil Mechanics and Foundation Design</h2>
                <h2><FontAwesomeIcon icon={faRoad} className="domain-icon" /> Transportation (Highway and Pavement Design)</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faWater} className="domain-icon" /> Water Resources Management</h2>
                <h2><FontAwesomeIcon icon={faLeaf} className="domain-icon" /> Environmental Engineering</h2>
                <h2><FontAwesomeIcon icon={faRecycle} className="domain-icon" /> Water and Wastewater Treatment</h2>
                <h2><FontAwesomeIcon icon={faTrashAlt} className="domain-icon" /> Solid Waste Management</h2>
                </div>

            </div>
             
        </div>

         <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
              <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faHardHat} className="domain-icon" /> Construction Engineering and Management</h2>
                <h2><FontAwesomeIcon icon={faSatelliteDish} className="domain-icon" /> Remote Sensing and GIS</h2>
                <h2><FontAwesomeIcon icon={faLeaf} className="domain-icon" /> Sustainable and Green Building Design</h2>
                <h2><FontAwesomeIcon icon={faBolt} className="domain-icon" /> Energy Efficient Materials</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faCubes} className="domain-icon" /> Smart Materials and Structures</h2>
                <h2><FontAwesomeIcon icon={faCity} className="domain-icon" /> Urban Planning and Infrastructure Development</h2>
                <h2><FontAwesomeIcon icon={faAtom} className="domain-icon" /> Materials Engineering</h2>
                <h2><FontAwesomeIcon icon={faThLarge} className="domain-icon" /> Concrete Technology</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faCubes} className="domain-icon" /> Composite and Alternative Construction Materials</h2>
                <h2><FontAwesomeIcon icon={faTemperatureHigh} className="domain-icon" /> Thermal Engineering </h2>
                <h2><FontAwesomeIcon icon={faIndustry} className="domain-icon" /> Manufacturing Engineering</h2>
                <h2><FontAwesomeIcon icon={faCog} className="domain-icon" /> Production Processes</h2>
                </div>

            </div>
             
        </div>

 <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faRobot} className="domain-icon" /> CNC and Automation</h2>
                <h2><FontAwesomeIcon icon={faPrint} className="domain-icon" /> Additive Manufacturing (3D Printing)</h2>
                <h2><FontAwesomeIcon icon={faSlidersH} className="domain-icon" /> Dynamics and Control Systems</h2>
                <h2><FontAwesomeIcon icon={faSolarPanel} className="domain-icon" /> Renewable and Sustainable Energy Systems</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faCubes} className="domain-icon" /> Composite Materials</h2>
                <h2><FontAwesomeIcon icon={faMicroscope} className="domain-icon" /> Nano Fluidics and Micro Machining</h2>
                <h2><FontAwesomeIcon icon={faAtom} className="domain-icon" /> Nano Technology</h2>
                <h2><FontAwesomeIcon icon={faBrain} className="domain-icon" /> AI / Machine Learning in Mechanical Systems</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faPersonRunning} className="domain-icon" /> Biomechanics</h2>
                <h2><FontAwesomeIcon icon={faGears} className="domain-icon" /> Unconventional Machining Process</h2>
                <h2><FontAwesomeIcon icon={faBolt} className="domain-icon" /> Welding</h2>
                <h2><FontAwesomeIcon icon={faScrewdriverWrench} className="domain-icon" /> Hybrid Machining</h2>
                </div>

            </div>
        </div>

          <div className="maathagi_domain_main_div_1">
            <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faGasPump} className="domain-icon" /> Biodiesel in IC Engines</h2>
                <h2><FontAwesomeIcon icon={faOilCan} className="domain-icon" /> Engines and Alternate Fuels</h2>
                <h2><FontAwesomeIcon icon={faFireFlameCurved} className="domain-icon" /> Metallurgy and Heat Treatment</h2>
                <h2><FontAwesomeIcon icon={faWaveSquare} className="domain-icon" /> Acoustics and Vibrations (Machine Condition Monitoring)</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
               <div className="maathagi_domain_main_div_3">
                <h2><FontAwesomeIcon icon={faCogs} className="domain-icon" /> Applied Mechanics and Solid Mechanics</h2>
                <h2><FontAwesomeIcon icon={faAtom} className="domain-icon" /> Material Science and Metallurgy</h2>
                <h2><FontAwesomeIcon icon={faFlaskVial} className="domain-icon" /> Alloy design and treatment</h2>
                <h2><FontAwesomeIcon icon={faWater} className="domain-icon" /> Corrosion and surface engineering</h2>
                </div>

            </div>
             <div className="maathagi_domain_main_div_2">
                <div className="maathagi_domain_main_div_3">
                        <h2><FaHeartbeat style={{ marginRight: '8px' }} />Medical Signal Processing</h2>
                        <h2><FaMobileAlt style={{ marginRight: '8px' }} />Mobile Ad Hoc Network</h2>
                        <h2><FaBroadcastTower style={{ marginRight: '8px' }} />Mobile Communication</h2>
                        <h2><FaShieldAlt style={{ marginRight: '8px' }} />Network Security</h2>
                </div>
            </div>
        </div>

    </div>
    </div>
    {/* <div className="maathagi_domain_tools">
        <h2>TOOLS</h2>
    </div> */}
    {/* <div className="maathagi_domain_tools_1">
        <div className="maathagi_domain_tools_2">
           <div className="maathagi_domain_tools_3">
            <h2><FaPython />  Python</h2>
            <h2><FaWaveSquare />Block chain</h2>
            <h2><FaNetworkWired />Matlab</h2>
            <h2><FaShieldAlt /> Ansys Hfss</h2>
            </div>
        </div>
         <div className="maathagi_domain_tools_2">
            <div className="maathagi_domain_tools_3">
                <h2><FaMicrochip  /> Cadence</h2>
                <h2><FaSatelliteDish /> CST Studio Suite</h2>
                <h2><FaTools /> Tanner</h2>
                <h2><FaSatelliteDish /> Java</h2>
                
                </div>
        </div>
         <div className="maathagi_domain_tools_2">
           <div className="maathagi_domain_tools_3">
            <h2><FaNetworkWired  /> NS2 and NS3</h2>
            <h2><FontAwesomeIcon icon={faCar} /> Verilog - (Xilinx and Vivado)</h2>
            <h2><GiAtomicSlashes  /> Comsol Multiphysics</h2>
            <h2><FontAwesomeIcon icon={faAtom} /> Blender</h2>
            </div>
        </div>
    </div> */}

    {/* <div className="new_tools_topic_div">
            <div className="new_tools_topic_div_1">
                <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={python} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Python</h2>
                            
                              <h1>Python is a powerful, high-level programming language</h1>       
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={block_chain} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Block Chain</h2>
                            <h1>Blockchain is a decentralized, distributed digital ledger technology</h1>
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={matlab} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Matlab</h2>
                            <h1>MATLAB (Matrix Laboratory) is a high-performance programming language</h1>
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={ansys} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Ansys HFSS</h2>
                            <h1>ANSYS HFSS (High Frequency Structure Simulator) is a leading 3D electromagnetic (EM) simulation software.</h1>
                        </div>
                    </div>
                </div>
            </div>
            

              <div className="new_tools_topic_div_1">
                <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={cadence} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Cadence</h2>
                            
                              <h1>Cadence Design Systems is a leading provider of EDA (Electronic Design Automation) tools</h1>       
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={cst} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>CST Studio Suite</h2>
                            <h1>CST Studio Suite (by Dassault Systèmes) is a powerful 3D electromagnetic (EM) simulation software.</h1>
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={tanner} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Tanner</h2>
                            <h1>Tanner EDA (by Siemens) is a powerful Electronic Design Automation (EDA) tool used for analog, mixed-signal, MEMS, and IC design.</h1>
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={java} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Java</h2>
                            <h1>Java is a powerful, object-oriented, and platform-independent programming language.</h1>
                        </div>
                    </div>
                </div>
            </div>



             <div className="new_tools_topic_div_1">
                <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={ns2} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>NS2 & NS3</h2>
                            
                              <h1>NS2 (Network Simulator 2) and NS3 (Network Simulator 3) are widely used open-source network simulators.</h1>       
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={verilog} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Verilog - (Xilinx and Vivado)</h2>
                            <h1>Verilog HDL (Hardware Description Language) is widely used for digital circuit design and verification.</h1>
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={comsol} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Comsol Multiphysics</h2>
                            <h1>COMSOL Multiphysics is a powerful simulation software platform for modeling and solving physics-based problems.</h1>
                        </div>
                    </div>
                </div>
                 <div className="new_tools_topic_div_2">
                    <div className="new_tools_topic_div_3">
                        <img src={blender} alt=""/>
                        <div className="new_tools_conts">
                             <p>Course Duration: 3 Months ₹ 65,000 INR</p>
                            <h2>Blender</h2>
                            <h1>Blender is a free and open-source 3D creation suite used for modeling, animation, rendering, simulation, and video editing.</h1>
                        </div>
                    </div>
                </div>
            </div>
    </div> */}
    <Footer/>
    </>
)

}

export default Domains